import { RotaAssignment } from './RotaAssignment';
import { RotaRoleAssignment } from './RotaRoleAssignment';
import { RotaFullDayAbsenceAssignment } from './RotaFullDayAbsenceAssignment';
import { RotaAvailabilityAssignment } from './RotaAvailabilityAssignment';
import { RotaHalfDayAbsenceAssignment } from './RotaHalfDayAbsenceAssignment';

/**
 * A class which represents a full rota for one week.
 */
export class Rota {
  rotaAssignments: RotaAssignment[];
  roleAssignments: RotaRoleAssignment[];
  availabilityAssignments: RotaAvailabilityAssignment[];
  fullDayAbsenceAssignments: RotaFullDayAbsenceAssignment[];
  halfDayAbsenceAssignments: RotaHalfDayAbsenceAssignment[];

  /**
   * @param rotaAssignments assigned working hours for the employee (without a specific role)
   * @param roleAssignments the time periods where a specific employee is assigned to fulfill a specific task.
   * @param availabilityAssignments the time periods where an employee is deemed available to work (but not necessarily assigned)
   * @param fullDayAbsenceAssignments the full days, on which an employee is unavailable to work.
   * @param halfDayAbsenceAssignments the half days, on which an employee is unavailable to work.
   */
  constructor(
    rotaAssignments: RotaAssignment[],
    roleAssignments: RotaRoleAssignment[],
    availabilityAssignments: RotaAvailabilityAssignment[],
    fullDayAbsenceAssignments: RotaFullDayAbsenceAssignment[],
    halfDayAbsenceAssignments: RotaHalfDayAbsenceAssignment[]
  ) {
    this.rotaAssignments = rotaAssignments;
    this.roleAssignments = roleAssignments;
    this.availabilityAssignments = availabilityAssignments;
    this.fullDayAbsenceAssignments = fullDayAbsenceAssignments;
    this.halfDayAbsenceAssignments = halfDayAbsenceAssignments;
  }
}

